import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly DARK_MODE_KEY = 'darkMode';
  private readonly DARK_MODE_CLASS = 'dark-mode-selector';

  // Signal to track dark mode state
  isDarkMode = signal<boolean>(false);

  constructor() {
    // Initialize from localStorage or system preference
    this.initializeTheme();
  }

  private initializeTheme(): void {
    const savedPreference = localStorage.getItem(this.DARK_MODE_KEY);
    
    if (savedPreference !== null) {
      // Use saved preference
      const isDark = savedPreference === 'true';
      this.setDarkMode(isDark);
    } else {
      // Default to light mode
      this.setDarkMode(false);
    }
  }

  toggleDarkMode(): void {
    const newValue = !this.isDarkMode();
    this.setDarkMode(newValue);
    localStorage.setItem(this.DARK_MODE_KEY, String(newValue));
  }

  setDarkMode(isDark: boolean): void {
    this.isDarkMode.set(isDark);
    const htmlElement = document.documentElement;
    
    if (isDark) {
      htmlElement.classList.add(this.DARK_MODE_CLASS);
    } else {
      htmlElement.classList.remove(this.DARK_MODE_CLASS);
    }
  }
}

